export default {
  home: {
    hero: {
      badge: 'Shopping-Ressourcen-Hub 2026',
      title: 'Ihre vollständige Basetao Spreadsheet Ressource',
      subtitle:
        'Finden Sie nützliche Basetao-Tabellen, Produktlinks, Verkäufer-Guides, QC-Tipps und Versandhilfe — alles an einem Ort organisiert.',
      trust: 'Unabhängige Informationsressource für Basetao-Käufer.',
      categoryLabel: 'Nach Kategorie durchsuchen',
      categoryPlaceholder: 'Kategorie wählen…',
    },
    categories: {
      title: 'Nach Kategorie einkaufen',
      subtitle: 'Springen Sie direkt zu den gewünschten Produkten auf der Hauptwebsite.',
    },
    intro: {
      eyebrow: 'Was ist das',
      title: 'Was ist eine Basetao Spreadsheet?',
      p1: 'Eine Basetao Spreadsheet ist ein organisiertes Dokument, das Ihnen hilft, jedes Produkt, jeden Verkäufer, Preis und jedes QC-Detail beim Einkauf über den Basetao-Agenten zu verfolgen.',
      p2: 'Sie hält Ihre Links, Größen, Farben und den Versandfortschritt an einem Ort, damit Sie nie den Überblick über eine Bestellung verlieren oder versehentlich zu viel ausgeben.',
    },
    features: {
      title: 'Alles für clevereres Einkaufen',
      subtitle: 'Von Produktlinks bis zur endgültigen Lieferung — bleiben Sie bei jedem Schritt organisiert.',
      items: [
        {
          title: 'Ausgewählte Kategorien',
          desc: 'Durchsuchen Sie 14 Produktkategorien und springen Sie direkt zu dem, was Sie möchten.',
        },
        {
          title: 'Verkäufer-Guides',
          desc: 'Verstehen Sie, wie Sie Shops vergleichen und vertrauenswürdige Verkäufer wählen.',
        },
        {
          title: 'QC-Tipps',
          desc: 'Wissen Sie, was Sie prüfen sollten, bevor Ihre Artikel das Lager verlassen.',
        },
        {
          title: 'Versandhilfe',
          desc: 'Machen Sie sich mit Versandmethoden und den Grundlagen der Kosten vertraut.',
        },
      ],
    },
    articleTeaser: {
      eyebrow: 'Empfohlener Guide',
      title: 'Der vollständige Basetao Spreadsheet Guide',
      desc: 'Erfahren Sie, wie Sie eine Basetao Spreadsheet erstellen und nutzen, um Produktlinks, Verkäufer, QC-Fotos und Versanddetails zu organisieren.',
      readMore: 'Den vollständigen Guide lesen',
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      items: [
        {
          q: 'Was ist Basetao Spreadsheet?',
          a: 'Es ist eine Informationsressource, die Produktlinks, Kategorien und Einkaufs-Guides organisiert, damit Basetao-Käufer schneller finden, was sie brauchen.',
        },
        {
          q: 'Verkaufen Sie Produkte direkt?',
          a: 'Nein. Wir verlinken auf die Hauptwebsite, wo Sie die Produkte durchsuchen und kaufen können.',
        },
        {
          q: 'Ist dies die offizielle Basetao-Website?',
          a: 'Nein. Dies ist eine unabhängige Informationsressource und nicht die offizielle Basetao-Website, sofern nicht ausdrücklich anders angegeben.',
        },
        {
          q: 'Wie nutze ich das Kategorie-Dropdown?',
          a: 'Öffnen Sie das Dropdown, wählen Sie eine Kategorie und Sie werden zur passenden Seite auf der Hauptwebsite weitergeleitet.',
        },
      ],
    },
    finalCta: {
      title: 'Bereit, die Basetao Spreadsheet Ressourcen zu entdecken?',
      subtitle: 'Durchsuchen Sie die Kategorien unten oder besuchen Sie die Hauptwebsite, um mit dem Einkauf zu beginnen.',
    },
  },
};